import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass']
})
export class LoadingComponent implements OnInit {
  @Input() diameter: number = 25
  constructor() { }

  ngOnInit() {
  }

}
